import { IS_LOGIN } from "./type"

export const is_login = (param) => ({
    type: IS_LOGIN,
    prm: param
})